var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIconTable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9814 3.60534L12.3934 5.01667M11.8894 2.36201L8.07136 6.18001C7.87409 6.37701 7.73955 6.628 7.6847 6.90134L7.33203 8.66667L9.09736 8.31334C9.3707 8.25867 9.62136 8.12467 9.8187 7.92734L13.6367 4.10934C13.7514 3.99461 13.8424 3.8584 13.9045 3.7085C13.9666 3.55859 13.9986 3.39793 13.9986 3.23567C13.9986 3.07342 13.9666 2.91275 13.9045 2.76285C13.8424 2.61294 13.7514 2.47674 13.6367 2.36201C13.522 2.24728 13.3858 2.15627 13.2359 2.09417C13.086 2.03208 12.9253 2.00012 12.763 2.00012C12.6008 2.00012 12.4401 2.03208 12.2902 2.09417C12.1403 2.15627 12.0041 2.24728 11.8894 2.36201Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.666 10V12C12.666 12.3536 12.5255 12.6928 12.2755 12.9428C12.0254 13.1929 11.6863 13.3333 11.3327 13.3333H3.99935C3.64573 13.3333 3.30659 13.1929 3.05654 12.9428C2.80649 12.6928 2.66602 12.3536 2.66602 12V4.66668C2.66602 4.31305 2.80649 3.97392 3.05654 3.72387C3.30659 3.47382 3.64573 3.33334 3.99935 3.33334H5.99935",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconTable);
export default __webpack_public_path__ + "static/media/edit-icon-table.0f5a15b88be6574e7807b36b0d7a0f99.svg";
export { ForwardRef as ReactComponent };